/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

/**
 * Open (buy) or close (sell) a position
 */
export type PlaceOrderDtoAction = (typeof PlaceOrderDtoAction)[keyof typeof PlaceOrderDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaceOrderDtoAction = {
  buy: 'buy',
  sell: 'sell',
} as const;
